module.exports = __webpack_public_path__ + "img/opensea.dc6c6381.svg";